import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/dirt-bikes-for-sale/[slug]/components/ProductDetailPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Chip.tsx");
